import { graphql } from "relay-runtime"

const deSigningSubscription = graphql`
  subscription deSigningSubscription($signRequestId: UUID!) {
    de_documentSigned(signRequestId: $signRequestId) {
      documentId
      signedAt
      signedBy
      signRequestId
    }
  }
`

export { deSigningSubscription }
